import {useContext} from 'react'
import { IoIosCloseCircleOutline } from "react-icons/io";
import NewsContext from '../context/News/NewsContext';
import _ from "lodash"
const Topics = ({close,setActiveTopic}) => {
    const {topics}=useContext(NewsContext)
    return (
        <div className="Register">
        <div className="Login__container">
          <div style={{ textAlign: "right" }}>
            <IoIosCloseCircleOutline
              size={40}
              style={{ cursor: "pointer" }}
              onClick={close}
            />
          </div>
              <h3>Select a News Topic that you would like to explore</h3>
              <div style={{textAlign: 'left'}}>
                  <ul>      {topics.map(c=><li className="topicName" style={{marginTop:"3px",cursor: "pointer",lineHeight:"36px" }} onClick={()=>{setActiveTopic(c);close();}}><b>{_.startCase(_.toLower(c))}</b></li>)}
        </ul>
        
        </div>
        </div>
      </div>
    
    )
}

export default Topics
